<template>
  <div class="trigger" :class="{ mobile: isMobile }">
    <h6 v-if="!(isEditingAlert && isMobile)">
      <span v-if="isMobile" @click="backToIndexPage">
        <fa icon="chevron-left" class="icon"></fa>
      </span>
      Trigger
    </h6>
    <p>Select the prefix or set of prefixes that trigger the alert:</p>
    <span v-if="isMobile" class="separate-line"></span>
    <div class="trigger-type">
      <div class="form-check">
        <input
          type="radio"
          class="form-check-input"
          id="prefix-announced-by-asn"
          :value="TRIGGER_TYPE.PREFIX_ANNOUNCED_BY_ASN"
          v-model="triggerType"
        />
        <label for="prefix-announced-by-asn" class="form-check-label"
          >Any prefix announced by the ASN.</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          class="form-check-input"
          id="prefix-delegated-to-account"
          :value="TRIGGER_TYPE.PREFIX_DELEGATED_TO_ACCOUNT"
          v-model="triggerType"
        />
        <label for="prefix-delegated-to-account" class="form-check-label"
          >All prefixes delegated to your account.</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          class="form-check-input"
          id="prefix-selected-individually"
          :value="TRIGGER_TYPE.PREFIX_SELECTED_INDIVIDUALLY"
          v-model="triggerType"
        />
        <label for="prefix-selected-individually" class="form-check-label"
          >Select individual prefixes.</label
        >
      </div>
    </div>
    <!-- <p v-show="isSelectedPrefixListEmpty" class="text-danger warning">
      At least one prefix must be selected.
    </p> -->
    <div
      v-if="triggerType === TRIGGER_TYPE.PREFIX_SELECTED_INDIVIDUALLY"
      class="prefix-select-section"
    >
      <input
        type="text"
        class="prefix-query form-control"
        placeholder="Type prefix number"
        v-model="prefixQuery"
      />
      <div class="scroll-area">
        <VueCustomScrollbar :settings="settings">
          <ul>
            <li v-for="item in filteredPrefixList" :key="item.prefix">
              <div class="form-group form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="selectedPrefixList"
                  :value="item.prefix"
                  :id="item.prefix"
                />
                <label class="form-check-label" :for="item.prefix">
                  <span>
                    {{ item.prefix }}
                  </span>
                  <span v-if="!item.isBelongingToMember"> *</span>
                </label>
              </div>
            </li>
          </ul>
        </VueCustomScrollbar>
      </div>
      <div class="prefix-select-section__footer">
        <button type="button" class="btn btn-primary" @click="toggleSelectAll">
          {{ isSelectedAll ? 'Remove All' : 'Select All' }}
        </button>
        <span>* - indicate prefixes not held by your account</span>
      </div>
    </div>
  </div>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar';
import { mapGetters, mapState } from 'vuex';
import { TRIGGER_TYPE } from '../../../constants/alertsConstant';

export default {
  components: { VueCustomScrollbar },
  name: 'Trigger',
  props: ['prevSelectedPrefixList', 'prefixList', 'prevTriggerType'],
  data() {
    return {
      prefixQuery: '',
      settings: {
        suppressScrollY: false,
        suppressScrollX: true,
        wheelPropagation: true
      },
      selectedPrefixList: [],
      TRIGGER_TYPE: TRIGGER_TYPE,
      triggerType: this.prevTriggerType
    };
  },
  computed: {
    ...mapGetters(['isMobile']),
    ...mapState('alertsSuspiciousTrafficStore', ['isEditingAlert']),
    filteredPrefixList() {
      if (!this.prefixList || !this.prefixList.length) return [];

      const filteredList = this.prefixList.filter(
        item => item.prefix.indexOf(this.prefixQuery) > -1
      );

      this.selectedPrefixList = this.selectedPrefixList.filter(
        selectedPrefix =>
          !!filteredList.find(item => item.prefix === selectedPrefix)
      );

      this.$emit('updateSelectedPrefixList', this.selectedPrefixList);

      return filteredList;
    },
    isSelectedAll() {
      return (
        this.filteredPrefixList.length === this.selectedPrefixList.length &&
        this.filteredPrefixList.length > 0
      );
    }
    // isSelectedPrefixListEmpty() {
    //   return this.selectedPrefixList.length === 0;
    // }
  },
  watch: {
    triggerType: {
      // immediate: true,
      handler(val) {
        this.$emit('onTriggerTypeChange', val);
      }
    }
  },
  mounted() {
    this.selectedPrefixList = this.prevSelectedPrefixList;

    // this.$nextTick(() => {
    //   if (!this.selectedPrefixList.length) this.toggleSelectAll();
    // });
  },
  methods: {
    toggleSelectAll() {
      if (!this.isSelectedAll) {
        this.selectedPrefixList = [...this.filteredPrefixList].map(
          item => item.prefix
        );
      } else {
        this.selectedPrefixList = [];
      }
    },
    backToIndexPage() {
      this.$emit('backToIndexPage');
    }
  }
};
</script>

<style lang="scss" scoped>
.trigger {
  position: relative;
  padding: 2rem 1.5rem;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;

  & > p {
    line-height: 1.5rem;
    margin-bottom: 0;
  }
}

h6 {
  font-weight: 600;

  & > span {
    font-size: 1.2rem;
    padding: 0.5rem 1rem;
    margin-left: -1rem;
    vertical-align: bottom;
    color: $text-light-blue;
  }
}

.separate-line {
  @include separate-line;
}

.trigger-type {
  margin: 0.5rem 0;

  & > div {
    padding: 0.25rem 0 0.25rem 1.5rem;
  }
}

p.warning {
  margin-top: 0.5rem;
  margin-bottom: -0.5rem;
}

.prefix-select-section {
  height: calc(100% - 12.5rem);

  &__footer {
    margin-top: 0.5rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  @media screen and (min-width: 992px) {
    &__footer {
      span {
        margin-left: 2rem;
      }
    }
  }

  @media screen and (min-width: 1550px) {
    &__footer {
      width: 66%;
      justify-content: space-between;
    }
  }
}

input.prefix-query {
  width: 66%;
  min-width: 20rem;
  margin-top: 0rem;
}
.scroll-area {
  width: 66%;
  min-width: 20rem;
  min-height: 5rem;
  max-height: calc(100% - 3rem);
  overflow-y: scroll;
  border: 1px solid $text-grey;

  /deep/ .ps__rail-y {
    background-color: #eee;
    opacity: 0.9;
  }
  /deep/ .ps__thumb-y {
    width: 11px;
  }

  ul {
    padding: 0.5rem 1rem;
    list-style: none;
  }
  li {
    height: 2.5rem;
    min-height: 2.5rem;
    line-height: 2.5rem;

    & > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0;

      input {
        margin-top: -0.1rem;
        height: 1.2rem;
        width: 1.2rem;
      }
      label {
        padding-left: 0.5rem;
      }
    }
  }
}

.mobile {
  padding: 1rem;

  h6 {
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1rem;
  }

  p.warning {
    margin-top: -0.5rem;
    margin-bottom: 0.5rem;
  }

  .trigger-type {
    margin-top: -0.5rem;
    & > div {
      padding: 0.25rem 0 0.25rem 1.5rem;
    }
  }

  .prefix-query {
    margin-top: 0rem;
  }

  .scroll-area {
    min-height: 5rem;
    max-height: calc(100% - 7.5rem);
  }

  .prefix-select-section {
    &__footer {
      margin-top: 0.5rem;
      display: flex;
      flex-direction: column-reverse;
      align-items: flex-start;

      span {
        margin-bottom: 0.5rem;
        font-size: 0.8rem;
      }
    }
  }
}
</style>
